
import { Database } from '@/integrations/supabase/types';

// Define Message type for chatbot conversations
export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date | string; // Allow both Date and string to handle serialization
}

// Define the missing types for chatbot_user_conversations table
export interface ChatbotUserConversation {
  id: string;
  user_id: string;
  messages: Message[];
  created_at: string;
  updated_at: string;
}

// Extending the Database type with our custom tables
export type ExtendedDatabase = Database & {
  public: {
    Tables: {
      chatbot_user_conversations: {
        Row: ChatbotUserConversation;
        Insert: {
          id?: string;
          user_id: string;
          messages: Message[];
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          messages?: Message[];
          created_at?: string;
          updated_at?: string;
        };
      };
    } & Database['public']['Tables'];
  };
};

// Helper function to prepare messages for storage in Supabase
// This converts Date objects to strings for JSON serialization
export const prepareMessagesForStorage = (messages: Message[]): any[] => {
  return messages.map(msg => ({
    ...msg,
    timestamp: msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp
  }));
};

// Helper function to prepare messages from storage
// This converts string timestamps back to Date objects
export const prepareMessagesFromStorage = (messages: any[]): Message[] => {
  return messages.map(msg => ({
    ...msg,
    timestamp: typeof msg.timestamp === 'string' ? new Date(msg.timestamp) : msg.timestamp
  }));
};
